import { useCallback } from 'react';
import { Quill } from 'seagull/patches/PatchedQuill';
import '../TemplateVariableBlot/TemplateVariableBlot';
export function useInsertVariableIntoQuill(editorElRef) {
    return useCallback((label)=>{
        const editorEl = editorElRef.current;
        if (!editorEl) return;
        const quill = Quill.find(editorEl);
        if (!quill) return;
        const range = quill.getSelection(true);
        if (range.length > 0) {
            quill.deleteText(range.index, range.length, 'user');
        }
        quill.insertEmbed(range.index, 'template-variable', {
            label
        }, 'user');
        quill.setSelection(range.index + 1, 0, 'silent');
    }, [
        editorElRef
    ]);
}
